import { useContext } from 'react';

import { PartnerIntakeContext } from '@/Contexts/PartnerIntakeContext';

import ExistingPartnerSelect from '../common/ExistingPartnerSelect';
import NewPartnerSection from '../common/IntakeNewPartnerSection';
import NewPartnerSectionHeader from '../common/IntakeNewPartnerSectionHeader';
import IntakePrimaryContact from '../common/IntakePrimaryContact';
import IntakeShippingContact from '../common/IntakeShippingContact';
import IntakeSubmitButton from '../common/IntakeSubmitButton';
import NewPartnerCheckbox from '../common/NewPartnerCheckbox';
import PartnerCategoryInput from '../common/PartnerCategoryInput';
import PartnerNameInput from '../common/PartnerNameInput';
import { IntakeResponse } from '@/models/IntakeResponse';
import { ProgramProps } from '@/models/Program';

interface TreeCityUsaSignUpProps {
  onSubmit: (intakeResponse: IntakeResponse) => void;
  selectedProgramInfo: ProgramProps;
}

function TreeCityUsaSignUp({ onSubmit, selectedProgramInfo }: TreeCityUsaSignUpProps) {
  const { isNewPartner, disabledNewPartnerCheckbox } = useContext(PartnerIntakeContext);

  return (
    <>
      <IntakePrimaryContact />
      {!isNewPartner && <ExistingPartnerSelect />}

      {!disabledNewPartnerCheckbox && <NewPartnerCheckbox />}

      {isNewPartner && (
        <NewPartnerSection>
          <NewPartnerSectionHeader />

          {selectedProgramInfo.displayCategory && <PartnerCategoryInput />}

          <PartnerNameInput />
          <IntakeShippingContact />
        </NewPartnerSection>
      )}
      <IntakeSubmitButton onSubmit={onSubmit} />
    </>
  );
}

export default TreeCityUsaSignUp;
